import type { CameraMapPin } from '@/types'

// #247 — pure helpers behind the fleet map's filter bar.

export type PinStatus = 'online' | 'offline' | 'unknown'
export type PinStatusFilter = 'all' | PinStatus
export interface MapPinFilter {
  status: PinStatusFilter
  group: string | null
  query: string
}
export const emptyMapPinFilter: MapPinFilter = { status: 'all', group: null, query: '' }

export function statusOf(pin: CameraMapPin): PinStatus {
  return pin.is_online === true ? 'online' : pin.is_online === false ? 'offline' : 'unknown'
}

export function countByStatus(pins: CameraMapPin[]): Record<PinStatusFilter, number> {
  const counts = { all: pins.length, online: 0, offline: 0, unknown: 0 }
  for (const p of pins) counts[statusOf(p)] += 1
  return counts
}

export function groupsOf(pins: CameraMapPin[]): string[] {
  return Array.from(new Set(pins.flatMap((p) => p.group_names))).sort((a, b) => a.localeCompare(b))
}

export const isFiltering = (f: MapPinFilter) => f.status !== 'all' || f.group !== null || f.query.trim() !== ''

export function filterPins(pins: CameraMapPin[], f: MapPinFilter): CameraMapPin[] {
  const q = f.query.trim().toLowerCase()
  return pins.filter((p) => {
    if (f.status !== 'all' && statusOf(p) !== f.status) return false
    if (f.group !== null && !p.group_names.includes(f.group)) return false
    if (q && !p.name.toLowerCase().includes(q) && !(p.location ?? '').toLowerCase().includes(q)) return false
    return true
  })
}
